import React, { Fragment, useState } from 'react';
import PropTypes from 'prop-types';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';

const ShowResultsSelector = ({ options, selected, onClick }) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const toggle = () => setDropdownOpen((prevState) => !prevState);

  return (
    <Dropdown isOpen={dropdownOpen} toggle={toggle} data-testid="per-page-view-selector">
      <DropdownToggle color="secondary" caret>
        {selected}
      </DropdownToggle>
      <DropdownMenu>
        {options.map((opt) => <DropdownItem key={opt} value={opt} onClick={onClick}>{opt}</DropdownItem>)}
      </DropdownMenu>
    </Dropdown>
  );
};

export const ChooseResults = ({ options, selected, onClick }) => {
  return (
    <Fragment>
      <div>
        <span>
          Exibir&nbsp;
          <ShowResultsSelector options={options} selected={selected} onClick={onClick} />
                    &nbsp;resultados
        </span>
      </div>
    </Fragment>
  );
};

ChooseResults.propTypes = {
  options: PropTypes.array.isRequired,
  selected: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  onClick: PropTypes.func.isRequired,
};
